import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-chevron-right',
  styleUrls: ['./chevron-right.component.scss'],
  templateUrl: './chevron-right.component.html'
})
export class ChevronRightComponent {}
